var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loader-container" }, [
    _c("img", {
      attrs: { src: require("@assets/images/loader.svg"), alt: "loader" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }